import React, { useState, useRef, useEffect } from 'react';
import { useTheme } from '../../../contexts/ThemeContext';
import DatePicker from './DatePicker';

const NL_MONTHS_SHORT = ['jan','feb','mrt','apr','mei','jun','jul','aug','sep','okt','nov','dec'];

function formatDisplay(value) {
  if (!value) return 'Kies datum';
  const [y, m, d] = value.split('-').map(Number);
  if (!y || !m || !d) return value;
  return `${d} ${NL_MONTHS_SHORT[m - 1]} ${y}`;
}

export default function DatePickerField({ value, onChange }) {
  const { colors, themeMode } = useTheme();
  const isLight = themeMode === 'light';
  const [open, setOpen] = useState(false);
  const triggerRef = useRef();
  const popoverRef = useRef();
  const [pos, setPos] = useState({ top: 0, left: 0 });

  useEffect(() => {
    if (!open) return;
    const rect = triggerRef.current?.getBoundingClientRect();
    if (!rect) return;
    const popH = 320;
    const spaceBelow = window.innerHeight - rect.bottom;
    const top = spaceBelow > popH + 8
      ? rect.bottom + 6
      : rect.top - popH - 6;
    const left = Math.min(rect.left, window.innerWidth - 280 - 16);
    setPos({ top, left });
  }, [open]);

  useEffect(() => {
    if (!open) return;
    const handle = (e) => {
      if (
        !triggerRef.current?.contains(e.target) &&
        !popoverRef.current?.contains(e.target)
      ) setOpen(false);
    };
    document.addEventListener('mousedown', handle);
    return () => document.removeEventListener('mousedown', handle);
  }, [open]);

  const border = isLight ? 'rgba(0,0,0,0.10)' : 'rgba(255,255,255,0.09)';
  const triggerBg = open
    ? 'rgba(249,115,22,0.10)'
    : isLight ? 'rgba(0,0,0,0.04)' : 'rgba(255,255,255,0.06)';
  const triggerBorder = open ? 'rgba(249,115,22,0.35)' : border;

  const handleChange = (val) => {
    onChange(val);
    setOpen(false);
  };

  return (
    <>
      <button
        ref={triggerRef}
        onClick={() => setOpen(o => !o)}
        style={{
          background: triggerBg,
          border: `1px solid ${triggerBorder}`,
          borderRadius: 8,
          padding: '5px 10px',
          fontSize: 14,
          fontWeight: 600,
          color: open ? '#f97316' : colors.text,
          cursor: 'pointer',
          transition: 'all 0.15s',
          whiteSpace: 'nowrap',
          fontFamily: 'inherit',
        }}
      >
        {formatDisplay(value)}
      </button>

      {open && (
        <div
          ref={popoverRef}
          data-modal="true"
          style={{
            position: 'fixed',
            top: pos.top,
            left: pos.left,
            zIndex: 99999,
            background: colors.surface,
            border: `1px solid ${border}`,
            borderRadius: 16,
            boxShadow: '0 8px 32px rgba(0,0,0,0.25)',
            padding: '16px',
            width: 280,
          }}
        >
          <DatePicker value={value} onChange={handleChange} />
        </div>
      )}
    </>
  );
}
